document.addEventListener('alpine:init', () => {
  window.Alpine.data('pagination', () => ({
    maxElems: 3,
    shift: 1,
    pagination: [1,2,3],

    init() {
      this.updatePagination();

      this.$watch('window.Alpine.store("pageData").maxPage', () => this.updatePagination());
    },

    updatePagination() {
      const { page, maxPage } = window.Alpine.store('pageData');

      this.updateShift();

      this.pagination = [];

      if (maxPage > 3) {
        if (page > (this.maxElems - 1)) {
          this.pagination.push({
            num: 1,
            active: false,
          });
        }

        if (page > (this.maxElems + this.shift - 1)) {
          this.pagination.push({
            num: '...',
            active: false,
            disabled: true,
          });
        }
      }

      for (let i = 0; i < (maxPage > this.maxElems? this.maxElems : maxPage ); i++) {
        this.pagination.push({
          num: i + (page - this.shift),
          active: i + (page - this.shift) === page
        });
      }

      if (page < (maxPage - Math.ceil(this.maxElems / 2)) + this.shift - 1) {
        this.pagination.push({
          num: '...',
          active: false,
          disabled: true,
        });
      }

      if (page < (maxPage - Math.ceil(this.maxElems / 2) + this.shift)) {
        this.pagination.push({
          num: maxPage,
          active: false,
        });
      }
    },

    /**
     * added: maxPage > 2 to the second condition
     * because the pagination goes wrong only when there are 2 pages of results.
     *
     * I don't understand the 'shift' concept here and why it's needed, though.
     * Leaving it all as unchanged as possible.
     */
    updateShift() {
      const { page, maxPage } = window.Alpine.store('pageData');

      if(page === 1) {
        this.shift = 0;
      } else if (page === maxPage && maxPage > 2) {
        this.shift = 2;
      } else {
        this.shift = 1;
      }
    },

    shouldShowArrowLeft() {
      return this.$store.pageData.page > 1;
    },

    shouldShowArrowRight() {
      return this.$store.pageData.page < this.$store.pageData.maxPage;
    },

    onArrowLeftClick() {
      this.$store.pageData.page = 1;

      this.updatePagination();
      this.updatePosts();
    },

    onArrowRightClick() {
      this.$store.pageData.page = this.$store.pageData.maxPage;

      this.updatePagination();
      this.updatePosts();
    },

    onPaginationItemClick(item) {
      if (item.disabled) {
        return;
      }

      this.$store.pageData.page = item.num;
      this.updatePagination();
      this.updatePosts();
    }
  }));
});
